import React from 'react';
import Adminnistrative from '../components/assets/images/Profile/NOFOTOADMIN.png';

const Administrative = () => {

};

export default Administrative;
